<!--
	分页参数                描述                                   默认值
	total                 总条目数                                   0
	page-size             每页显示条目个数                           20
	page-count            总页数                                 Math.ceil
	current-page          当前页数                                  1
	page-sizes           每页显示个数选择器的选项设置              [20,50,100]

	//event
	size-change      pageSize 改变时会触发              回调参数： 每页条数size
	current-change   currentPage 改变时会触发           回调参数： 当前页currentPage
		- 上一页
		- 下一页
		- 首页
		- 末页
	@size-change="handleSizeChange"
	@current-change="handleCurrentChange"
 -->

<template>
<div class="pagination cSub vaM_E" :class="{disable:pagination.total==0}">
	<span>{{$t('word20',['每页数量'])+":"}}</span>
	<Select :list="pageSize" :dir="'up'" :bindActive="pagination.request.size" @Click="sizeChange"></Select>
	<div class="group cb bdSub_E tra-fast_E" v-if="styleType=='max'">
		<button class="fa fa-angle-double-left" :title="$t('cmd1',['首页'])" :class="{disable: pagination.request.page === 1}" @click="goPage(1)"></button>
		<button class="fa fa-angle-left" :title="$t('cmd2',['上一页'])" :class="{disable: pagination.request.page === 1}" @click="goPage(pagination.request.page-1)"></button>
	</div>
	<div class="group cb bdSub_E tra-fast_E" v-if="styleType=='max'">
		<span v-if="pagination.request.page > 4" class="cSub">....</span>
		<button @click="goPage(page)" v-for="(page,index) in totalPages" :key="index"
				v-if="(index >= pagination.request.page - 4 ) && (index < pagination.request.page + 3)"
				:class="{active:(index+1) === pagination.request.page}">{{page}}
		</button>
		<span v-if="totalPages - pagination.request.page >= 4" class="cSub">....</span>
	</div>
	<div class="group cb bdSub_E tra-fast_E" v-if="styleType=='max'">
		<button class="fa fa-angle-right" :title="$t('cmd3',['下一页'])" :class="{disable: totalPages === pagination.request.page}" @click="goPage(pagination.request.page+1)"></button>
		<button class="fa fa-angle-double-right" :title="$t('cmd4',['尾页'])" :class="{disable: totalPages === pagination.request.page}" @click="goPage(totalPages)"></button>
	</div>
	<span v-if="styleType=='max'">
		<InputText class="w4x dpIB" name="inputPage" :addClass="'sizeS'" v-model="inputPage" :only="'absInt'" :fn="goPage"></InputText> / <span class="cMain b">{{totalPages}}</span>
		<!--
		<input type="text" class="bdSub w4x tra-fast" v-model="inputPage"
				 v-number-only
				 @keypress.enter="goPage(inputPage)"> / <span class="b">{{totalPages}}</span>
		 -->
		<span>{{$t('word18',['页'])}}</span>
		<span class="cMain b">{{pagination.total}}</span>
		<span>{{$t('word19',['个结果'])}}</span>
	</span>
</div>
</template>
<script>
import Select from '@/components/common/ui/Select.vue'
import InputText from '@/components/common/ui/InputText.vue'

let defPagination = {
	request: {
		page: 1,
		size: 20
	},
	total: 0
	// totalPages: 0
}
export default {
	name: 'Pagination',
	components: {Select, InputText},
	props: {
		styleType: {
			type: String,
			default: 'max'
		},
		pagination: {
			type: Object,
			default: (function () {
				return $.extend(true, {}, defPagination)
			}())
		},
		getList: {
			type: Function,
			default: function () {}
		},
		pageSize: {
			type: Array,
			default: () => ([{text: 20, value: 20}, {text: 100, value: 100}, {text: 200, value: 200}, {text: 500, value: 500}])
		}
	},
	data () {
		return {
			inputPage: defPagination.request.page,
			totalPages: 0
		}
	},
	watch: {
		// pagination:{
		// 	deep:true,
		// 	handler:function(){
		// 		// this.getTotalPages();
		// 	}
		// },
		'pagination.request.page' (val) {
			this.inputPage = val
		},
		'pagination.total': function (val, oldV) {
			this.getTotalPages(val, oldV)
		}
	},
	directives: {
		numberOnly: {
			bind: function (el) {
				el.handler = function () {
					el.value = el.value.replace(/\D+/, '')
				}
				el.addEventListener('input', el.handler)
			},
			unbind: function (el) {
				el.removeEventListener('input', el.handler)
			}
		}
	},
	methods: {
		getTotalPages: function (val, oldV) {
			this.totalPages = Math.ceil(this.pagination.total / this.pagination.request.size) || 0
			let maxPage = Math.ceil(val /  this.pagination.request.size);
			if (maxPage < this.inputPage && maxPage > 0) {
					this.inputPage = maxPage;
					this.goPage(this.inputPage)
			}
		},
		sizeChange: function (index) {
			this.pagination.request.page = 1
			this.pagination.request.size = this.pageSize[index].value
			this.getTotalPages()
			this.getList()
		},
		goPage (page) {
			page = Number(page)
			if (page > this.totalPages) page=this.totalPages;
			else if (page < 1) page = 1
			this.pagination.request.page = this.inputPage = page;
			
			this.$nextTick(()=>{
				this.$set(this,"inputPage",page);
			});
			// this.$emit('current-change', page)
			this.getList();
		}
	},
	// computed:{
	// },
	created () {
		$.extend(true, this.pagination, defPagination)
		this.pagination.request.size = this.pageSize[0].value
		this.inputPage = this.pagination.request.page
	},
	mounted () {
		// this.$watch("pagination.total",function(){
		//   trace(this.pagination.total,true)
		// });
		// this.$nextTick(function(){
		// 	trace(this.pagination)
		// });
		// this.pagination=$.extend(this.pagination,defPagination);
		// this.pagination={...this.pagination,...defPagination};
		// this.$set(this,"inputPage",this.pagination.page);
	}
}
</script>
<style lang="scss" scoped>
.pagination{display:inline-block;
	>*{vertical-align:middle;}
	>div+*{margin:{left:1em;};}
	.group{display:inline-block;
		>:first-child{border-radius:$radiusLight 0 0 $radiusLight;}
		>:last-child{border-radius:0 $radiusLight $radiusLight 0;}
		>:first-child:last-child{border-radius:$radiusLight;}
		>*{height:2em;padding:{left:1em;right:1em;};display:block;float:left;line-height:1;}
		>button+button{border:{left:none;};}
		>[active],>.active,>button:hover{border-color:$mainColor;background-color:$mainColor;color:#fff;}
		>span{border:none;background-color:transparent !important;}
	}
	[type="text"]{height:2em;}
}
//tr .flipPage{padding:{top:0;bottom:0;};}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Pagination.vue